import React from 'react';
import { useT } from '@/lib/i18n';
import { LegalLayout } from '@/components/legal/LegalLayout';

const Mentions = () => {
  const { lang } = useT();
  const fr = (
    <>
      <h2>Éditeur du site</h2>
      <p><strong>HighlightAI</strong><br />
      Raison sociale : <strong>[À COMPLÉTER — ex. HighlightAI SAS]</strong><br />
      Forme juridique : [À COMPLÉTER]<br />
      Capital social : [À COMPLÉTER]<br />
      Siège social : [À COMPLÉTER — adresse complète]<br />
      SIRET : [À COMPLÉTER]<br />
      Numéro de TVA intracommunautaire : [À COMPLÉTER]<br />
      Directeur de la publication : [À COMPLÉTER — nom du représentant légal]<br />
      Email : <a href="mailto:contact@highlightai.online">contact@highlightai.online</a></p>

      <h2>Hébergement</h2>
      <p>Le site est hébergé sur l&apos;infrastructure <strong>Emergent</strong> (Kubernetes managé) avec stockage objet sécurisé. Les serveurs sont localisés dans l&apos;Union européenne.</p>

      <h2>Propriété intellectuelle</h2>
      <p>L&apos;ensemble du contenu présent sur HighlightAI (textes, graphismes, logos, code source, marques) est protégé par le droit d&apos;auteur et le droit des marques. Toute reproduction, modification ou exploitation sans autorisation expresse est strictement interdite.</p>
      <p>Les vidéos uploadées par les utilisateurs restent leur propriété exclusive. HighlightAI ne revendique aucun droit sur le contenu uploadé.</p>

      <h2>Responsabilité</h2>
      <p>HighlightAI s&apos;efforce d&apos;assurer la disponibilité et l&apos;exactitude du service. Toutefois, en raison de la nature des contenus traités par intelligence artificielle, aucune garantie n&apos;est fournie quant à la pertinence absolue des clips générés.</p>

      <h2>Droit applicable</h2>
      <p>Le présent site est soumis au droit français. Tout litige relève de la compétence exclusive des tribunaux français.</p>
    </>
  );
  const en = (
    <>
      <h2>Publisher</h2>
      <p><strong>HighlightAI</strong><br />
      Legal entity: <strong>[TO COMPLETE — e.g. HighlightAI SAS]</strong><br />
      Legal form: [TO COMPLETE]<br />
      Share capital: [TO COMPLETE]<br />
      Registered office: [TO COMPLETE — full address]<br />
      SIRET: [TO COMPLETE]<br />
      VAT number: [TO COMPLETE]<br />
      Publication director: [TO COMPLETE]<br />
      Email: <a href="mailto:contact@highlightai.online">contact@highlightai.online</a></p>

      <h2>Hosting</h2>
      <p>The site is hosted on <strong>Emergent</strong> infrastructure (managed Kubernetes) with secure object storage. Servers are located in the European Union.</p>

      <h2>Intellectual property</h2>
      <p>All content on HighlightAI (texts, graphics, logos, source code, trademarks) is protected by copyright and trademark law. Any reproduction, modification or exploitation without express authorization is strictly prohibited.</p>
      <p>Videos uploaded by users remain their exclusive property. HighlightAI does not claim any rights over uploaded content.</p>

      <h2>Liability</h2>
      <p>HighlightAI strives to ensure service availability and accuracy. However, due to the AI-generated nature of the output, no warranty is provided as to the absolute relevance of the generated clips.</p>

      <h2>Governing law</h2>
      <p>This site is governed by French law. Any dispute falls under the exclusive jurisdiction of French courts.</p>
    </>
  );
  return <LegalLayout titleFr="Mentions légales" titleEn="Legal notice">{lang === 'fr' ? fr : en}</LegalLayout>;
};

export default Mentions;
